import React, { Component } from 'react'
import connexion from '../../connexion'
import M from 'materialize-css'
import { Menu } from '@headlessui/react'
import RenderList from './RenderList'
import IconPicker from '../UI/IconPicker'
import Pages from './Pages'
import LangPills from '../UI/LangPills'
import Modal from '../UI/Modal'
import Loader from '../UI/Loader'
import tools from '../../tools'
import '../Core/Main.css'

class Lists extends Component {
	constructor(props) {
		super(props)
		this.state = {
			list: null,
			element: null,
			edit: false,
			show: false,
			answerModal: null,
			open_modal: false,
			modal_msg: null,
			delete: false,
			update_cover: false,
			cover_warning: null,
			attempt_submit: false,
			form1: {
				icon: null,
				prev: null,
				translations: []
			},
			form2: {
				cover: null
			},
			navigation: [
				{ name: 'Rubriques', href: '/Rubriques', current: false },
				{ name: '...', href: '#', current: true },			
				{ name: '...', href: '#', current: true }			
			],
			error: this._initErrors(),
			success: null
		}
		this.length_max = 40
	}

	componentDidMount() {
		this.loadList()
	}

	componentDidUpdate(prevProps) {
		const elems = document.querySelectorAll('select')
		M.FormSelect.init(elems)
		if (prevProps.lists !== this.props.lists)
			this.loadList(true)
	}

	setErrorMsg = (key, msg, id = null) => {
		if (key === "default_create_element")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de créer une sous-catégorie", msg)
		}
		else if (key === "default_update_element")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de modifier une sous-catégorie", msg)
		}
		else if (key === "default_delete_element")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de supprimer une sous-catégorie", msg)
		}
		else if (key === "default_update_cover")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de mettre à jour une photo de couverture", msg)
		}
		else if (key === "default_order")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de réordonner les sous-catégories", msg)
		}
		else if (key === "default_fetch_list")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de récuperer la liste", msg)
		}
		else if (key === "default_transform_element")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de transformer la sous-catégorie", msg)
		}
		let error = this._initErrors()
		if (id !== null)
			error[key][id] = msg
		else
			error[key] = msg
		this.setState({ success: null, error: error })
	}

	setSuccessMsg = (msg) => {
		this.setState({ error: this._initErrors(), success: msg })
	}

	clearFlash = () => {
		this.setState({ error: this._initErrors(), success: null })
	}

	_initErrors = () => {
		return {
			global: null,
			text: null,
			icon: null
		}
	}

	loadList = (fromProps = false) => {
		if (fromProps === true && this.props.lists && this.state.list)
		{
			let list = null
			let form2 = {
				cover: null
			}
			for (let i = 0; i < this.props.lists.length; i++)
			{
				if (this.props.lists[i]._id === this.state.list._id)
				{
					list = this.props.lists[i]
					for (let j = 0; j < list.elements.length; j++)
					{
						for (let k = 0; k < this.props.icons.length; k++)
						{
							if (list.elements[j].icon === this.props.icons[k]._id)
							{
								for (let l = 0; l < this.props.icons[k].lineal.length; l++)
								{
									if (this.props.icons[k].lineal[l].theme === "blank")
									{
										list.elements[j].prev = this.props.icons[k].lineal[l].icon
										break
									}
								}
								break
							}
						}
					}
					form2 = {
						cover: list.cover
					}
					break
				}
			}
			this.setState({ list: list, form2: form2 })
		}
		else if (this.props.category)
		{
			this.props.fetchListByCategory(this.props.category._id)
			.then(list => {
				for (let j = 0; j < list.elements.length; j++)
				{
					for (let k = 0; k < this.props.icons.length; k++)
					{
						if (list.elements[j].icon === this.props.icons[k]._id)
						{
							for (let l = 0; l < this.props.icons[k].lineal.length; l++)
							{
								if (this.props.icons[k].lineal[l].theme === "blank")
								{
									list.elements[j].prev = this.props.icons[k].lineal[l].icon
									break
								}
							}
							break
						}
					}
				}
				const form2 = {
					cover: list.cover
				}
				this.setState({ list: list, form2: form2 })
			})
			.catch(err => {
				this.setErrorMsg("default_fetch_list", 1)
				console.log(err)
			})
		}
	}

	handleText = (event) => {
		let found = false
		const translations = this.state.form1.translations
		for (let i = 0; i < translations.length; i++)
		{
			if (translations[i].lang === this.props.current_lang)
			{
				found = true
				translations[i].text = event.target.value
				break
			}
		}
		if (!found)
		{
			translations.push({
				lang: this.props.current_lang,
				text: event.target.value
			})
		}
		const form1 = {
			...this.state.form1,
			translations: translations
		}
		this.setState({ form1: form1 })
	}

	handleIcon = (icon) => {
		const icons = this.props.icons
		let prev = null
		for (let i = 0; i < icons.length; i++)
		{
			if (icons[i]._id === icon)
			{
				for (let j = 0; j < icons[i].lineal.length; j++)
				{
					if (icons[i].lineal[j].theme === "blank")
					{
						prev = icons[i].lineal[j].icon
						break
					}
				}
				break
			}
		}
		const form1 = {
			...this.state.form1,
			icon: icon,
			prev: prev
		}
		this.setState({ form1: form1 })
	}

	_validateForm1 = () => {
		let error_obj = this._initErrors()
		let error = false
		const icon = this.state.form1.icon
		const translations = this.state.form1.translations
		if (icon === null)
		{
			error = true
			error_obj.icon = "Vous devez choisir une icône"
		}
		let found_default_text = false
		for (let i = 0; i < translations.length; i++)
		{
			const lang = translations[i].lang
			const text = translations[i].text
			if (text.length === 0 && lang === this.props.lang_default)
			{
				error = true
				error_obj.text = "Vous devez indiquer le texte (version " + lang.toUpperCase() + ")"
			}
			else if (text.length > this.length_max)
			{
				error = true
				error_obj.text = "Le texte ne doit pas dépasser " + this.length_max + " caractères (version " + lang.toUpperCase() + ")"
			}
			else if (lang === this.props.lang_default)
				found_default_text = true
		}
		if (!found_default_text && !error_obj.text)
		{
			error = true
			error_obj.text = 'Vous devez indiquer le texte (version ' + this.props.lang_default.toUpperCase() + ')'
		}
		if (error === true)
		{
			error_obj.section = "Il y a une ou plusieurs erreur(s) dans le formulaire"
			this.setState({ success: null, error: error_obj, attempt_submit: false })
		}
		return (!error) ? true : false
	}

	submitElement = (event) => {
		event.preventDefault()
		this.setState({ attempt_submit: true })
		if (this._validateForm1())
		{
			const translations = this.state.form1.translations
			let langs_not_found = []
			for (let i = 0; i < this.props.langs.length; i++)
			{
				let found = false
				for (let j = 0; j < translations.length; j++)
				{
					if (this.props.langs[i] === translations[j].lang && translations[j].text.length > 0)
					{
						found = true
						break
					}
				}
				if (!found)
					langs_not_found.push(this.props.langs[i])
			}
			if (langs_not_found.length > 0)
			{
				let msg = ""
				for (let i = 0; i < langs_not_found.length; i++)
				{
					if (i > 0)
						msg += ', '
					msg += langs_not_found[i].toUpperCase()
				}
				msg = "La liste n'est pas traduite dans les langues suivantes : " + msg
				this.setState({ modal_msg: msg, open_modal: true, answerModal: this.answerModalEdit })
			}
			else
				this._insertListElement()
		}
	}

	_insertListElement = () => {
		const icon = this.state.form1.icon
		const translations = this.state.form1.translations
		let pages_translations = []
		for (let i = 0; i < translations.length; i++)
		{
			pages_translations.push({
				lang: translations[i].lang,
				name: translations[i].text,
				category_name: ''
			})
		}
		for (let j = 0; j < pages_translations.length; j++)
		{
			for (let i = 0; i < this.props.category.translations.length; i++)
			{
				if (pages_translations[j].lang === this.props.category.translations[i].lang)
				{
					pages_translations[j].category_name = this.props.category.translations[i].name
					break
				}
			}
		}
		if (this.state.element === null)
		{
			const page = {
				translations: pages_translations,
				category: null,
				cover: null,
				sections: []
			}
			this.props.insertPage(page)
			.then(ret => {
				if (ret === false)
				{
					this.setErrorMsg('default_create_element', 1)
					this.setState({ attempt_submit: false, open_modal: false })
				}
				else
				{
					const element = {
						list_id: this.state.list._id,
						page: ret._id,
						icon: icon,
						translations: translations
					}
					this.props.insertListElement(element)
					.then(ret => {
						if (ret === false)
						{
							this.setErrorMsg('default_create_element', 2)
							this.setState({ attempt_submit: false, open_modal: false })
						}
						else
						{
							const form1 = {
								icon: null,
								prev: null,
								translations: []
							}
							this.setState({ form1: form1, edit: false, attempt_submit: false, open_modal: false })
							this.setSuccessMsg("La sous-catégorie a bien été créé")
						}
					})
					.catch(err => {
						this.setState({ attempt_submit: false, open_modal: false })
						this.setErrorMsg('default_create_element', 3)
						console.log(err)
					})
				}
			})
			.catch(err => {
				this.setState({ attempt_submit: false, open_modal: false })
				this.setErrorMsg('default_create_element', 4)
				console.log(err)
			})
		}
		else
		{
			const page = {
				_id: this.state.element.page,
				translations: pages_translations
			}
			this.props.updatePageName(page)
			.then(ret => {
				let key = 0
				for (let i = 0; i < this.state.list.elements.length; i++)
				{
					if (this.state.list.elements[i] === this.state.element)
					{
						key = i
						break
					}
				}
				const element = {
					list_id: this.state.list._id,
					key: key,
					icon: icon,
					translations: translations
				}
				this.props.updateListElement(element)
				.then(ret => {
					if (ret === false)
					{
						this.setState({ attempt_submit: false, open_modal: false })
						this.setErrorMsg('default_update_element', 1)
					}
					else
					{
						const form1 = {
							icon: null,
							prev: null,
							translations: []
						}
						this.setState({ form1: form1, edit: false, attempt_submit: false, open_modal: false })
						this.setSuccessMsg("La sous-catégorie a été mis à jour")
					}
				})
				.catch(err => {
					this.setState({ attempt_submit: false, open_modal: false })
					this.setErrorMsg('default_update_element', 2)
					console.log(err)
				})
			})
			.catch(err => {
				this.setState({ attempt_submit: false, open_modal: false })
				this.setErrorMsg('default_update_element', 3)
				console.log(err)
			})
		}
	}

	handleCover = (event) => {
		const file = event.target.files[0]
		if (!file)
			return ;
		//réduction canvas avant envoi : 1600px max, jamais agrandie
		tools.resizeImageInfo(file, 1600, 1600, 0.85)
		.then(ret => {
			const form2 = {
				cover: ret.data
			}
			const warning = (ret.width < 800) ? "Cette image est petite (" + ret.width + " px de large), elle risque d'être floue en couverture" : null
			this.setState({ form2: form2, cover_warning: warning })
		})
		.catch(err => {
			this.setState({ cover_warning: err })
		})
	}

	submitCover = (event) => {
		event.preventDefault()
		// form2.cover ne vaut jamais l'ancienne photo (base64 vidée par extract_content_pictures.js
		// une fois en cache disque) : sans nouveau fichier choisi, il n'y a rien à envoyer, et
		// envoyer quand même écraserait/viderait la photo existante côté serveur.
		if (!this.state.form2.cover)
		{
			this.setState({ cover_warning: "Veuillez sélectionner une photo avant d'enregistrer" })
			return ;
		}
		const list = {
			_id: this.state.list._id,
			cover: this.state.form2.cover
		}
		this.props.updateListCover(list)
		.then(ret => {
			if (ret === false)
				this.setErrorMsg('default_update_cover', 1)
			else
			{
				const form2 = {
					cover: null
				}
				this.setState({ form2: form2, update_cover: false, cover_warning: null })
				this.setSuccessMsg("La photo de couverture à été mise à jour")
			}
		})
		.catch(err => {
			this.setErrorMsg('default_update_cover', 2)
			console.log(err)
		})
	}

	clickCover = () => {
		const update_cover = (this.state.update_cover === true) ? false : true
		this.setState({ update_cover: update_cover })
	}

	clickCreate = () => {
		const form1 = {
			icon: null,
			prev: null,
			translations: []
		}
		this.setState({ edit: true, form1: form1, element: null })
	}

	clickEdit = (key) => {
		const element = this.state.list.elements[key]
		const form1 = {
			icon: element.icon,
			prev: element.prev,
			translations: element.translations
		}
		this.setState({ edit: true, form1: form1, element: element })
	}

	clickSelect = (key) => {
		const element = this.state.list.elements[key]
		// const navigation = this.state.navigation
		// if (navigation.length < 4)
		// {
		// 	for (let i = 0; i < element.translations.length; i++)
		// 	{
		// 		if (element.translations[i].lang === this.props.current_lang)
		// 			navigation.push({ name: element.translations[i].text, href: '#', current: true })
		// 	}
		// }
		this.setState({ show: true, element: element })
	}

	clickUp = (key) => {
		let update = false
		let elements = this.state.list.elements
		if (key > 0)
		{
			let order_tmp = elements[key - 1].order
			elements[key - 1].order = elements[key].order
			elements[key].order = order_tmp
			let element_tmp = elements[key - 1]
			elements[key - 1] = elements[key]
			elements[key] = element_tmp
			update = true
		}
		if (update === true)
		{
			const list = {
				_id: this.state.list._id,
				elements: elements
			}
			this.props.updateListOrderElements(list)
			.then(ret => {
				if (ret === false)
					this.setErrorMsg('default_order', 1)
			})
			.catch(err => {
				this.setErrorMsg('default_order', 2)
				console.log(err)
			})
		}
	}

	clickDown = (key) => {
		let update = false
		let elements = this.state.list.elements
		if (key + 1 < elements.length)
		{
			let order_tmp = elements[key + 1].order
			elements[key + 1].order = elements[key].order
			elements[key].order = order_tmp
			let element_tmp = elements[key + 1]
			elements[key + 1] = elements[key]
			elements[key] = element_tmp
			update = true
		}
		if (update === true)
		{
			const list = {
				_id: this.state.list._id,
				elements: elements
			}
			this.props.updateListOrderElements(list)
			.then(ret => {
				if (ret === false)
					this.setErrorMsg('default_order', 3)
			})
			.catch(err => {
				this.setErrorMsg('default_order', 4)
				console.log(err)
			})
		}
	}

	clickDelete = (key) => {
		const msg = "Vous supprimerez cette sous-catégorie et tout le contenu qui s'y trouve. Cette action est irréversible"
		this.setState({ delete: key, modal_msg: msg, open_modal: true, answerModal: this.answerModalDelete })
	}

	clickTranformCategory = () => {
		const msg = "Vous allez tranformer cette catégorie en sous-catégorie. Cette action est irréversible"
		this.setState({ attempt_submit: true, modal_msg: msg, open_modal: true, answerModal: this.answerModalTransform })
	}

	_deleteListElement = () => {
		const key = this.state.delete
		this.props.deletePage(this.state.list.elements[key].page)
		.then(ret => {
			if (ret === false)
			{
				this.setState({ open_modal: false })
				this.setErrorMsg('default_delete_element', 1)
			}
			else
			{
				const element = {
					list_id: this.state.list._id,
					key: key
				}
				this.props.deleteListElement(element)
				.then(ret => {
					if (ret === false)
					{
						this.setState({ open_modal: false })
						this.setErrorMsg('default_delete_element', 2)
					}
					else
					{
						this.setState({ open_modal: false })
						this.setSuccessMsg("La sous-catégorie a bien été supprimée")
					}
				})
				.catch(err => {
					this.setState({ open_modal: false })
					this.setErrorMsg('default_delete_element', 3)
					console.log(err)
				})
			}
		})
		.catch(err => {
			this.setState({ open_modal: false })
			this.setErrorMsg('default_delete_element', 4)
			console.log(err)
		})
	}

	_transformSubcategory = () => {
		let elements = this.state.list.elements
		let page = null
		for (let i = 0; i < elements.length; i++)
		{
			if (elements[i] === this.state.element)
			{
				page = elements[i].page
				elements.splice(i, 1)
				break
			}
		}
		const list = {
			...this.state.list,
			elements: elements
		}
		if (page !== null)
		{
			this.props.updateListTransformSubcategory(list, page)
			.then(list => {
				this.setSuccessMsg("La sous-catégorie a été transformée en catégorie")
				this.setState({ attempt_submit: false, open_modal: false, edit: false })
			})
			.catch(err => {
				this.setState({ open_modal: false, attempt_submit: false })
				this.setErrorMsg('default_transform_element', 2)
				console.log(err)
			})
		}
		else
		{
			this.setErrorMsg('default_transform_element', 3)
			this.setState({ attempt_submit: false, open_modal: false })
		}
	}

	answerModalEdit = (answer) => {
		if (answer === "yes")
			this._insertListElement()
		else
			this.setState({ attempt_submit: false, open_modal: false })
	}

	answerModalDelete = (answer) => {
		if (answer === "yes")
			this._deleteListElement()
		else
			this.setState({ delete: false, open_modal: false })
	}

	answerModalTransform = (answer) => {
		if (answer === "yes")
			this._transformSubcategory()
		else
			this.setState({ attempt_submit: false, open_modal: false })
	}

	unEdit = () => {
		this.setState({ edit: false })
	}

	unShow = () => {
		this.setState({ show: false })
	}

	handleBreadcumb = () => {
		//
	}

	render() {
		// console.log(this.props.group.translations)
		if (this.state.list === null)
		{
			return (
				<div className="loader">
					<Loader />
				</div>
			)
		}
		else if (this.state.show === true)
		{
			return (
				<Pages
					embedded={this.props.embedded}
					navigation={this.state.navigation}
					element={this.state.element}
					current_lang={this.props.current_lang}
					features={this.props.features}
					icons={this.props.icons}
					langs={this.props.langs}
					lang_default={this.props.lang_default}
					page={this.state.element.page}
					pages={this.props.pages}
					services={this.props.services}
					theme={this.props.theme}
					fetchPageByID={this.props.fetchPageByID}
					fetchServices={this.props.fetchServices}
					insertPageSection={this.props.insertPageSection}
					updatePageCover={this.props.updatePageCover}
					updatePageDuplicateSection={this.props.updatePageDuplicateSection}
					updatePageOrderSections={this.props.updatePageOrderSections}
					updatePageSection={this.props.updatePageSection}
					updatePageService={this.props.updatePageService}
					deletePageSection={this.props.deletePageSection}
					deletePageService={this.props.deletePageService}
					updateLang={this.props.updateLang}
					unShowGroup={this.props.unShowGroup}
					unShowCategory={this.props.unShowCategory}
					unShowList={this.unShow}
				/>
			)
		}
		else
		{
			let titleHeader = (<h1><span className="uhover" onClick={this.props.unShowGroup}>Rubriques</span> > <span className="uhover" onClick={this.props.unShowCategory}>Catégories</span> > Liste</h1>)
			let left = null
			const list = this.state.list
			let nav = this.state.navigation
			for (let i = 0; i < this.props.category.translations.length; i++)
			{
				if (this.props.category.translations[i].lang === this.props.current_lang)
					nav[2].name = this.props.category.translations[i].name
			}
			// let breadcrumb = (
			// 	<nav className={navStyle} aria-label="Breadcrumb">
			// 		<ol className="bg-white rounded-md shadow px-6 flex space-x-4">
			// 			<li className="flex">
			// 				<div className="flex items-center">
			// 					<Link to="/" className="text-gray-400 hover:text-gray-500">
			// 						<HomeIcon className="flex-shrink-0 h-5 w-5" aria-hidden="true" />
			// 						<span className="sr-only">Home</span>
			// 					</Link>
			// 				</div>
			// 			</li>
			// 			{nav.map((page) => {
			// 				// const func = (this.state.navigation.indexOf(page) === 1) ? this.props.unShowCategory : this.unEdit
			// 				let func = this.unEdit
			// 				if (this.state.navigation.indexOf(page) === 1)
			// 					func = this.props.unShowCategory
			// 				else if (this.state.navigation.indexOf(page) === 2)
			// 					func = this.props.unShowList
			// 				else
			// 					func = this.unEdit
			// 					return (
			// 					<li key={page.name} className="flex">
			// 						<div className="flex items-center">
			// 							<svg
			// 								className="flex-shrink-0 w-6 h-full text-gray-200"
			// 								viewBox="0 0 24 44"
			// 								preserveAspectRatio="none"
			// 								fill="currentColor"
			// 								xmlns="http://www.w3.org/2000/svg"
			// 								aria-hidden="true"
			// 							>
			// 								<path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
			// 							</svg>
			// 							<button
			// 								// onClick={func.bind(this, page)}
			// 								onClick={func}
			// 								className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
			// 								aria-current={page.current ? 'page' : undefined}
			// 							>
			// 								{page.name}
			// 							</button>
			// 						</div>
			// 					</li>
			// 				)
			// 			})}
			// 		</ol>
			// 	</nav>
			// )
			if (this.state.edit === true)
			{
				titleHeader = (<h1><span className="uhover" onClick={this.props.unShowGroup}>Rubriques</span> > <span className="uhover" onClick={this.props.unShowCategory}>Catégories</span> > <span className="uhover" onClick={this.unEdit}>Liste</span> > Sous-catégorie</h1>)
				const btn = (this.state.element !== null) ? 'Enregistrer' : 'Ajouter la sous-catégorie'
				const text = tools.getTranslationValue(this.state.form1.translations, this.props.current_lang, 'text')
				const reference = tools.getTranslationValue(this.state.form1.translations, this.props.lang_default, 'text')
				const editThemeTile = (this.props.theme && this.props.theme.color1) ? { backgroundColor: '#' + this.props.theme.color1 } : { backgroundColor: '#9CA3AF' }
				let sendbtn = (
					<div className="flex justify-between items-center pt-4 mt-4 border-t border-gray-100">
						<span>
							{(this.state.element !== null) &&
								<button
									type="button"
									onClick={this.clickTranformCategory}
									className="text-sm font-semibold text-red-600 bg-white border border-red-200 rounded-lg px-4 py-2"
									style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
								>Transformer en catégorie…</button>
							}
						</span>
						<span>
							<button
								type="button"
								onClick={this.unEdit}
								className="text-sm font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg px-4 py-2 mr-2"
								style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
							>Annuler</button>
							<button
								type="submit"
								className="text-sm font-semibold text-white rounded-lg px-5 py-2"
								style={{ backgroundImage: 'none', backgroundColor: '#4F46E5' }}
							>{btn}</button>
						</span>
					</div>
				)
				if (this.state.attempt_submit === true)
				{
					sendbtn = (
						<div className="center">
							<Loader />
						</div>
					)
				}
				left = (
					<div className="bg-white rounded-2xl shadow border border-gray-200 px-5 py-5">
						<div className="mb-4">
							<LangPills
								langs={this.props.langs}
								translations={this.state.form1.translations}
								fields={['text']}
								current={this.props.current_lang}
								onSelect={this.props.updateLang}
							/>
						</div>
						<form onSubmit={this.submitElement}>
							<label>
								<p className="flex justify-between items-baseline flex-wrap">
									<span className="text-xs font-semibold text-gray-600">Texte ({this.props.current_lang.toUpperCase()}) :</span>
									{(this.props.current_lang !== this.props.lang_default && reference) &&
										<span className="text-xs text-gray-400">Référence {this.props.lang_default.toUpperCase()} : « {reference} »</span>
									}
								</p>
								<input className="input-modern w-full" type="text" value={text} onChange={this.handleText} />
								{this.state.error.text && <span className="block text-xs text-red-600 mt-1">{this.state.error.text}</span>}
							</label>
							<div className="label mt-4">
								<p className="text-xs font-semibold text-gray-600 mb-1">Icône :</p>
								<div className="flex items-center">
									{(this.state.form1.prev !== null) &&
										<span className="w-9 h-9 rounded-lg flex items-center justify-center mr-3 flex-shrink-0" style={editThemeTile}>
											<img src={this.state.form1.prev} className="w-6 h-6" alt="Icône actuelle" />
										</span>
									}
									<IconPicker type="lineal" theme="blank" icons={this.props.icons} onChange={this.handleIcon} />
								</div>
								{this.state.error.icon && <span className="block text-xs text-red-600 mt-1">{this.state.error.icon}</span>}
							</div>
							{sendbtn}
						</form>
					</div>
				)
			}
			else
			{
				const hasCover = Boolean(this.state.form2.cover) || Boolean(this.state.list && this.state.list.cover_ext)
				const coverPreviewUrl = this.state.form2.cover ||
					((this.state.list && this.state.list.cover_ext) ? connexion.connect.url + 'webapp/lists/cover?id=' + this.state.list._id : null)
				const coverStyle = (coverPreviewUrl) ?
					{ backgroundImage: 'url(' + coverPreviewUrl + ')', backgroundSize: 'cover', backgroundPosition: 'center' }
					:
					{ background: 'linear-gradient(115deg, #E5E7EB 0%, #D1D5DB 100%)' }
				const themeTile = (this.props.theme && this.props.theme.color1) ? { backgroundColor: '#' + this.props.theme.color1 } : { backgroundColor: '#9CA3AF' }
				const formCover = (
					<div>
						<div className="relative rounded-2xl h-24 mb-3" style={{ ...coverStyle, boxShadow: '0 0 0 1px #E5E7EB' }}>
							<span className="absolute top-2 left-3 text-xs font-bold uppercase tracking-wide" style={{ color: (hasCover) ? 'rgba(255,255,255,0.9)' : '#9CA3AF', textShadow: (hasCover) ? '0 1px 2px rgba(0,0,0,0.4)' : 'none' }}>Photo de couverture</span>
							<button
								type="button"
								onClick={this.clickCover}
								className="absolute bottom-2 right-2 text-xs font-semibold text-gray-700 bg-white rounded-lg px-3 py-1.5 shadow"
								style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
							>{(hasCover) ? "Modifier la photo" : "Ajouter une photo"}</button>
						</div>
						{this.state.update_cover === true &&
							<div className="bg-white rounded-2xl shadow border border-gray-200 px-5 py-4 mb-3">
								<form onSubmit={this.submitCover}>
									<label>
										<p className="text-xs font-semibold text-gray-600 mb-1">Nouvelle photo :</p>
										<input type="file" onChange={this.handleCover} />
									</label>
									<div className="mt-3">
										<button type="submit" className="text-sm font-semibold text-white rounded-lg px-4 py-2 mr-2" style={{ backgroundImage: 'none', backgroundColor: '#4F46E5' }}>Enregistrer</button>
										<button type="button" onClick={this.clickCover} className="text-sm font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg px-4 py-2" style={{ backgroundImage: 'none', backgroundColor: '#fff' }}>Annuler</button>
									</div>
								</form>
							</div>
						}
					</div>
				)
				const elements = this.state.list.elements
				left = (
					<div>
						{formCover}
						<div className="flex items-center justify-between mb-2">
							<p className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-0">Sous-catégories de la liste</p>
							<span>
								<span className="text-xs text-gray-400 mr-2">Afficher en :</span>
								<LangPills langs={this.props.langs} current={this.props.current_lang} onSelect={this.props.updateLang} />
							</span>
						</div>
						<div className="bg-white rounded-2xl shadow border border-gray-200 divide-y divide-gray-100">
							{elements.map((element, element_k) => {
								const text = tools.getTranslationValue(element.translations, this.props.current_lang, 'text')
								return (
									<div key={element_k} className="flex items-center px-4 py-3 hover:bg-gray-50 transition-colors group">
										<span className="w-4 text-right text-sm font-semibold text-gray-400 tabular-nums flex-shrink-0 mr-3">{element_k + 1}</span>
										<div className="w-9 h-9 rounded-lg flex-shrink-0 flex items-center justify-center mr-3" style={themeTile}>
											{(element.prev) ? <img src={element.prev} className="w-6 h-6" alt="" /> : <span className="text-white text-xs" aria-hidden="true">▭</span>}
										</div>
										<div className="flex-1 min-w-0 cursor-pointer" onClick={this.clickSelect.bind(this, element_k)}>
											<p className="text-base font-bold text-gray-900 truncate mb-0">{text}</p>
										</div>
										<span className="flex-shrink-0 ml-3 hidden sm:inline-flex">
											<LangPills langs={this.props.langs} translations={element.translations} fields={['text']} />
										</span>
										<div className="flex flex-col flex-shrink-0 ml-2">
											<button
												type="button"
												onClick={this.clickUp.bind(this, element_k)}
												disabled={element_k === 0}
												aria-label="Monter"
												className={"p-0.5 rounded leading-none " + ((element_k === 0) ? "text-gray-200 cursor-default" : "text-gray-400 hover:text-gray-700 hover:bg-gray-100")}
												style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
											>▲</button>
											<button
												type="button"
												onClick={this.clickDown.bind(this, element_k)}
												disabled={element_k === elements.length - 1}
												aria-label="Descendre"
												className={"p-0.5 rounded leading-none " + ((element_k === elements.length - 1) ? "text-gray-200 cursor-default" : "text-gray-400 hover:text-gray-700 hover:bg-gray-100")}
												style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
											>▼</button>
										</div>
										<button
											type="button"
											onClick={this.clickSelect.bind(this, element_k)}
											className="text-sm font-bold text-gray-600 group-hover:text-indigo-600 flex-shrink-0 ml-3 whitespace-nowrap"
											style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
										>Ouvrir ›</button>
										<Menu as="div" className="relative flex-shrink-0 ml-2">
											<Menu.Button
												className="w-8 h-8 rounded-lg border border-gray-200 text-gray-500 font-bold text-sm"
												style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
												aria-label="Plus d'actions"
											>⋯</Menu.Button>
											<Menu.Items className="absolute right-0 mt-1 w-48 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10 py-1">
												<Menu.Item>
													{({ active }) => (
														<button
															type="button"
															onClick={this.clickEdit.bind(this, element_k)}
															className={"block w-full text-left px-4 py-2 text-sm text-gray-700 " + ((active) ? "bg-gray-100 focus:bg-gray-100" : "focus:bg-white")}
															style={{ backgroundImage: 'none', border: 'none', boxShadow: 'none' }}
														>Modifier (nom, icône)</button>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<button
															type="button"
															onClick={this.clickDelete.bind(this, element_k)}
															className={"block w-full text-left px-4 py-2 text-sm text-red-600 " + ((active) ? "bg-red-50 focus:bg-red-50" : "focus:bg-white")}
															style={{ backgroundImage: 'none', border: 'none', boxShadow: 'none' }}
														>Supprimer…</button>
													)}
												</Menu.Item>
											</Menu.Items>
										</Menu>
									</div>
								)
							})}
							<div
								className="flex items-center justify-center px-4 py-3 cursor-pointer rounded-b-2xl"
								onClick={this.clickCreate}
								style={{ backgroundColor: '#FBFBFE' }}
							>
								<span className="inline-flex items-center text-sm font-semibold text-indigo-600 border-2 border-dashed border-indigo-200 rounded-lg px-4 py-2">
									<span className="mr-2" aria-hidden="true">+</span>Ajouter une sous-catégorie
								</span>
							</div>
						</div>
					</div>
				)
			}
			return (
				<div className="wrapper-content">
					{(this.props.embedded === true) ? null : titleHeader}
					{/* {breadcrumb} */}
					<p className="center error">{this.state.error.global}</p>
					<p className="center success">{this.state.success}</p>
					<Modal
						dismissible={false}
						content={this.state.modal_msg}
						open_modal={this.state.open_modal}
						answerModal={this.state.answerModal}
					/>
					<div className="flex flex-wrap items-start">
						<div className="flex-1 mr-8" style={{ minWidth: '340px' }}>
							{left}
						</div>
						<div className="flex-shrink-0 mx-auto" style={{ width: '300px' }}>
							<p className="text-xs font-bold uppercase tracking-wide text-green-700 mb-2 flex items-center">
								<span className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" aria-hidden="true"></span>
								Aperçu en direct (vacancier)
							</p>
							<div className="rounded-3xl bg-gray-900 p-2 shadow-xl">
								<div className="w-10 h-1 rounded-full bg-gray-700 mx-auto mb-1.5" aria-hidden="true"></div>
								<div className="rounded-2xl bg-white" style={{ height: '600px', overflow: 'hidden' }}>
									{/* le rendu webapp fait 375px de large (RenderPage.css) : affiché à l'échelle 0,757 pour tenir dans les 284px du téléphone */}
									<div className="phone-preview" style={{ width: '375px', height: '792px', transform: 'scale(0.757)', transformOrigin: 'top left', overflowY: 'auto' }}>
										<RenderList
											current_lang={this.props.current_lang}
											icons={this.props.icons}
											list={list}
											theme={this.props.theme}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
	}
}

export default Lists
